exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.hamburger[data-v-4e6f274c] {\n  display: inline-block;\n  vertical-align: middle;\n  width: 0.10417rem;\n  height: 0.10417rem;\n  fill: #004EA8;\n}\n.hamburger.is-active[data-v-4e6f274c] {\n  transform: rotate(180deg);\n}\n", ""]);

// exports
